export const setUSBDevice = (device) => ({
    type: 'SET_USB_DEVICE',
    payload: device,
  });